import { signInWithPopup } from "firebase/auth";
import { auth, provider, db } from "../firebase-config";
import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
import Logo from "./Logo";
import { TEXT_MUTED, BORDER } from "../theme";

function Auth() {
  const signIn = async () => {
    const result = await signInWithPopup(auth, provider);
    const user = result.user;

    const ref = doc(db, "users", user.uid);
    const snap = await getDoc(ref);

    if (!snap.exists()) {
      await setDoc(ref, {
        displayName: user.displayName,
        photoURL: user.photoURL,
        totalScore: 0,
        gamesPlayed: 0,
        gameHistory: {},
        createdAt: serverTimestamp(),
      });
    }
  };

  return (
    <div style={{ height: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "20px", textAlign: "center" }}>
      <div style={{ marginBottom: "28px" }}>
        <Logo size={36} />
      </div>

      <div style={{ padding: "14px 22px", border: `1px solid ${BORDER}`, borderRadius: "10px", marginBottom: "16px", color: TEXT_MUTED, fontSize: "0.875rem" }}>
        five minutes. one opponent. one decision.
      </div>

      <button
        onClick={signIn}
        style={{
          padding: "12px 26px",
          fontSize: "0.9375rem",
          background: "#fff",
          color: "#1a1a2e",
          border: `1px solid ${BORDER}`,
          borderRadius: "10px",
          fontWeight: "600",
          display: "flex",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="" style={{ width: "18px", height: "18px" }} />
        sign in with google
      </button>
    </div>
  );
}

export default Auth;
